export default __webpack_public_path__ + "icons_slope_ceiling-xxv.svg";